"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * ChiRhos API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class RelationshipApi extends runtime.BaseAPI {
    /**
     */
    apiRelationshipAcceptPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.value !== undefined) {
                queryParameters['value'] = requestParameters.value;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Relationship/Accept`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IRelationshipIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiRelationshipAcceptPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiRelationshipAcceptPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiRelationshipAcceptValuePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.value === null || requestParameters.value === undefined) {
                throw new runtime.RequiredError('value', 'Required parameter requestParameters.value was null or undefined when calling apiRelationshipAcceptValuePost.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Relationship/Accept/{value}`.replace(`{${"value"}}`, encodeURIComponent(String(requestParameters.value))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IRelationshipIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiRelationshipAcceptValuePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiRelationshipAcceptValuePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiRelationshipDeleteRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.entityId !== undefined) {
                queryParameters['entityId'] = requestParameters.entityId;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Relationship`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiRelationshipDelete(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiRelationshipDeleteRaw(requestParameters);
        });
    }
    /**
     */
    apiRelationshipGetPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Relationship/Get`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRequestToJSON(requestParameters.apiEntityRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IRelationshipIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiRelationshipGetPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiRelationshipGetPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
     */
    apiRelationshipImportPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.importIdentifier !== undefined) {
                queryParameters['importIdentifier'] = requestParameters.importIdentifier;
            }
            if (requestParameters.createDependencies !== undefined) {
                queryParameters['createDependencies'] = requestParameters.createDependencies;
            }
            const headerParameters = {};
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters.file !== undefined) {
                formParams.append('file', requestParameters.file);
            }
            const response = yield this.request({
                path: `/api/Relationship/Import`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IImportIStorableFromJSON(jsonValue));
        });
    }
    /**
     * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
     */
    apiRelationshipImportPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiRelationshipImportPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiRelationshipListForPersonPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Relationship/ListForPerson`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiEntityRequestToJSON(requestParameters.apiEntityRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.RelationshipContainerIEnumerableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiRelationshipListForPersonPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiRelationshipListForPersonPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * The sort applies to the order of the \'owned\' people returned, not the relationships. These are sorted internally.
     */
    apiRelationshipOwnedListAwaitingAcceptancePostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Relationship/Owned/ListAwaitingAcceptance`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiPagedRequestToJSON(requestParameters.apiPagedRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.RelationshipContainerHasMoreResponseFromJSON(jsonValue));
        });
    }
    /**
     * The sort applies to the order of the \'owned\' people returned, not the relationships. These are sorted internally.
     */
    apiRelationshipOwnedListAwaitingAcceptancePost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiRelationshipOwnedListAwaitingAcceptancePostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * The sort applies to the order of the \'owned\' people returned, not the relationships. These are sorted internally.
     */
    apiRelationshipOwnedListPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Relationship/Owned/List`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ApiPagedRequestToJSON(requestParameters.apiPagedRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.RelationshipContainerHasMoreResponseFromJSON(jsonValue));
        });
    }
    /**
     * The sort applies to the order of the \'owned\' people returned, not the relationships. These are sorted internally.
     */
    apiRelationshipOwnedListPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiRelationshipOwnedListPostRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     */
    apiRelationshipPostRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            const response = yield this.request({
                path: `/api/Relationship`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.RelationshipConstructToJSON(requestParameters.relationshipConstruct),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IRelationshipIStorableIDataResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiRelationshipPost(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiRelationshipPostRaw(requestParameters);
            return yield response.value();
        });
    }
}
exports.RelationshipApi = RelationshipApi;
